/* ==========================================================================
   NOOKISM. Cart (AJAX). Intercepts add-to-cart forms, re-renders the drawer
   from /cart.js, opens it, and handles line removal. Drawer open/close lives
   in nk-reveal.js (window.NK.openCart / fillIso).
   ========================================================================== */
(function(){
'use strict';

function money(cents, cur){
  try { return new Intl.NumberFormat(undefined, {style:'currency', currency: cur || 'AUD'}).format(cents/100); }
  catch(e){ return '$' + (cents/100).toFixed(2); }
}
function esc(s){
  return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
  });
}
function thumb(url){
  if (!url) return '';
  return url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_160x$1$2');
}

function setCount(n){
  document.querySelectorAll('[data-count]').forEach(function(b){
    b.setAttribute('data-count', n);
    var dot = b.querySelector('.dot');
    if (dot) dot.textContent = n;
    b.setAttribute('aria-label', 'Open cart, ' + n + ' items');
  });
}

function lineHTML(it, cur){
  var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0)
    ? '<span class="nk-line-variant">' + esc(it.variant_title) + '</span>' : '';
  var img = it.image
    ? '<a href="' + it.url + '" class="nk-line-img"><img src="' + thumb(it.image) + '" alt="" loading="lazy"></a>' : '';
  return '<div class="nk-line">' + img +
    '<div class="nk-line-info">' +
      '<a href="' + it.url + '" class="nk-line-name">' + esc(it.product_title) + '</a>' + variant +
      '<span class="nk-line-price">' + money(it.final_line_price, cur) + '</span>' +
      '<button type="button" class="nk-line-rm" data-line-remove="' + it.key + '">Remove</button>' +
    '</div></div>';
}

function render(cart){
  var body = document.querySelector('#nkDrawer [data-cart-body]');
  var foot = document.querySelector('#nkDrawer [data-cart-foot]');
  if (!body || !foot) return;
  if (!cart.item_count){
    body.classList.remove('has-items');
    body.innerHTML = '<div><div class="iso empty-iso" data-iso="riser"></div>' +
      '<p>Your cart is empty.<br>The kit you own becomes the room you need.</p></div>';
    foot.innerHTML = '<a href="/collections/all" class="nk-btn nk-btn--signal" data-cart-close ' +
      'style="width:100%;justify-content:center">Browse the kits</a>';
    if (window.NK && NK.fillIso) NK.fillIso(body);
    if (window.NK && NK.assembleStandalone) NK.assembleStandalone(body);
  } else {
    body.classList.add('has-items');
    body.innerHTML = cart.items.map(function(it){ return lineHTML(it, cart.currency); }).join('');
    foot.innerHTML =
      '<div class="nk-subtotal"><span>Subtotal</span><b>' + money(cart.total_price, cart.currency) + '</b></div>' +
      '<a href="/cart" class="nk-btn nk-btn--ghost" style="width:100%;justify-content:center;margin-bottom:10px">View cart</a>' +
      '<a href="/checkout" class="nk-btn nk-btn--signal" style="width:100%;justify-content:center">Checkout</a>';
  }
}

function refresh(open){
  return fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      setCount(cart.item_count);
      render(cart);
      if (open && window.NK && NK.openCart) NK.openCart();
      return cart;
    })
    .catch(function(){});
}

document.addEventListener('submit', function(e){
  var form = e.target.closest && e.target.closest('form[data-add-form], form[action$="/cart/add"]');
  if (!form) return;
  e.preventDefault();
  var btn = form.querySelector('[data-atc]');
  if (btn) btn.disabled = true;
  fetch('/cart/add.js', {method:'POST', body:new FormData(form), headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(){ return refresh(true); })
    .catch(function(){})
    .then(function(){ if (btn) btn.disabled = false; });
});

document.addEventListener('click', function(e){
  var rm = e.target.closest && e.target.closest('[data-line-remove]');
  if (!rm) return;
  e.preventDefault();
  fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json', 'Accept':'application/json'},
    body: JSON.stringify({ id: rm.dataset.lineRemove, quantity: 0 })
  }).then(function(r){ return r.json(); }).then(function(cart){ setCount(cart.item_count); render(cart); }).catch(function(){});
});

if (document.readyState !== 'loading') refresh(false);
else document.addEventListener('DOMContentLoaded', function(){ refresh(false); });

window.NK = window.NK || {};
window.NK.cartRefresh = refresh;
})();
